import axios from 'axios'
import router from "@/router/index";
import store from "@/store/index";
import Vue from "vue";
import JwtToken from "@/services/jwt-token";


let api = 'http://localhost:8000/';

if (process.env.NODE_ENV !== 'development') {
    api = 'https://api.analises.numerama.com.br'
}

const http = axios.create({
    baseURL: api
})

router.beforeEach((to, from, next) => {
    if (store.state.Auth.check && to.name === 'login') {
        return router.push({name: 'home'})
    }
    if (!store.state.Auth.check && to.meta.auth) {
        return router.push({name: 'login'})
    }
    next()
});

http.interceptors.request.use((config) => {
    const token = JwtToken.getAuthorizationHeader()
    if (token) {
        config.headers.Authorization = token
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

http.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status === 401 || error.response.status === 419) {
        let originalRequest = error.config
        return JwtToken.refreshToken().then(() => {
            originalRequest.headers['Authorization'] = JwtToken.getAuthorizationHeader()
            return Vue.http(originalRequest);
        }).catch(() => router.push({name: 'logout'}));
    }
    return Promise.reject(error)
})

export default http
